/**
 *
 * @param token to analyze
 * @returns true = invalid token
 *
 */

export const isTokenExpired = (token: string) => {
    if (!!token && token !== '') {
        const expiry = JSON.parse(atob(token.split('.')[1])).exp;
        const today = Math.floor(new Date().getTime() / 1000);
        console.log(
            'Expiry:', ((expiry / 60) / 60).toFixed(2),
            'Today:', ((today / 60) / 60).toFixed(2),
            'Expired:', today >= expiry,
            'CUANTO QUEDA PARA QUE EXPIRE:', ((expiry - today) / 60).toFixed(2), 'mintos'
        );

        return today >= expiry;
    } else {
        return true;
    }
};


export function getTokenExpiration(token: string): number {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp;
}